import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TransformAgoPipe } from './pipe.ago';

/**
 * The TransformAgoModule module
 *
 * import { TransformAgoModule } from 'styleguide/src/shared/pipe/ago/pipe.ago.module';
 */
@NgModule({
    declarations: [
        TransformAgoPipe
    ],
    imports: [
        CommonModule
    ],
    exports: [
        TransformAgoPipe
    ]
})

// tslint:disable-next-line:no-unnecessary-class
export class TransformAgoModule {}
